// extracted by mini-css-extract-plugin
export default {"radio-root":"Radio_radio-root__rdu3o"};